const PREFIX = 'pharmaconsensus-draft:';
const MAX_AGE = 7 * 24 * 60 * 60 * 1000;
export const validChoice = choice => choice === 'A' || choice === 'B';
export const draftDestination = (id, choice) => `/events/${encodeURIComponent(id)}${validChoice(choice) ? `?draft=${choice}` : ''}`;
export const saveDraft = (id, choice) => {
  if (!validChoice(choice)) return;
  try { localStorage.setItem(PREFIX + id, JSON.stringify({ choice, savedAt: Date.now() })); } catch { /* URL also carries the draft when storage is unavailable. */ }
};
export const clearDraft = id => { try { localStorage.removeItem(PREFIX + id); } catch {} };
export const readDraft = (id, search = '') => {
  const choice = new URLSearchParams(search).get('draft');
  if (validChoice(choice)) return choice;
  try {
    const draft = JSON.parse(localStorage.getItem(PREFIX + id));
    if (validChoice(draft?.choice) && Number.isFinite(draft.savedAt) && Date.now() - draft.savedAt < MAX_AGE && draft.savedAt <= Date.now()) return draft.choice;
  } catch {}
  return null;
};
export const eventIsOpen = event => event.status === 'active' && Date.parse(event.start_datetime) <= Date.now() && Date.parse(event.end_datetime) > Date.now();
export const displayDeadline = value => {
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? 'Date not available' : date.toLocaleString(undefined, { month: 'short', day: 'numeric', year: 'numeric', hour: 'numeric', minute: '2-digit', timeZoneName: 'short' });
};
export const sourceUrl = value => {
  try { const url = new URL(value); return ['https:', 'http:'].includes(url.protocol) ? url.href : null; } catch { return null; }
};
